import api from '../../boot/openapi';
import ApiError from './error';

const ProductService = {
  async getProducts() {
    const client = await api.getClient();
    try {
      return await client.searchProducts();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default ProductService;
